import { render, staticRenderFns } from "./ResetBlacklist.vue?vue&type=template&id=a2df31a2&scoped=true&"
import script from "./ResetBlacklist.vue?vue&type=script&lang=js&"
export * from "./ResetBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./ResetBlacklist.vue?vue&type=style&index=0&id=a2df31a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2df31a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VIcon,VLayout,VProgressLinear})
